const EARTH_RADIUS = 6371; // радиус земли

export const calcDistanceByCoords = (x1, y1, x2, y2) => {
  return Math.sqrt(Math.pow(x2 - x1, 2) + Math.pow(y2 - y1, 2));
};

const degreesToRadians = degrees => degrees * (Math.PI / 180); // градусы в радианы
const radiansToDegrees = radians => radians * (180 / Math.PI); // радианы в градусы

// угл между двумя точками от центра сферы
const centralSubtendedAngle = (locationX, locationY) => {
  const locationXLatRadians = degreesToRadians(locationX.latitude);
  const locationYLatRadians = degreesToRadians(locationY.latitude);

  return radiansToDegrees(
    Math.acos(
      Math.sin(locationXLatRadians) * Math.sin(locationYLatRadians) +
      Math.cos(locationXLatRadians) *
      Math.cos(locationYLatRadians) *
      Math.cos(degreesToRadians(Math.abs(locationX.longitude - locationY.longitude))),
    ),
  );
};

// расстояния между двумя точками с учетом центрального угла
const greatCircleDistance = angle => 2 * Math.PI * EARTH_RADIUS * (angle / 360);

// расстояние на поверхности сферы между двумя координатами
export const calcDistanceByLocations = (locationX, locationY) =>
  greatCircleDistance(centralSubtendedAngle(locationX, locationY));
